// extracted by mini-css-extract-plugin
export default {"head":"ObjectItemHead_head__s0k3s","title":"ObjectItemHead_title__0fvrE","street":"ObjectItemHead_street__DQVAK","video":"ObjectItemHead_video__BGfox"};